<div class="lib-manage-delegates">
  @if (showAddDelegateButton) {
    <div class="lib-md--toolbar">
      <button type="button" class="lib-md--add-btn" (click)="openAddDelegate()">
        <span class="lib-md--add-icon" aria-hidden="true">
          <img [src]="plusIconSrc" width="16" height="16" alt="" />
        </span>
        Add Delegate
      </button>
    </div>
  }

  <div class="lib-md--body">
    <div
      class="lib-md--filters"
      [class.lib-md--filters-open]="filtersOpen()"
      [class.lib-md--filters-dropdown-open]="
        statusDropdownOpen() || dateRangeOpen()
      "
    >
      <img
        class="lib-md--filters-leaf"
        [src]="leafImageSrc"
        alt=""
        aria-hidden="true"
      />
      <div
        class="lib-md--filters-header"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="filtersOpen()"
        (click)="toggleFilters()"
        (keydown.enter)="toggleFilters()"
        (keydown.space)="toggleFilters(); $event.preventDefault()"
      >
        <span class="lib-md--filters-left">
          <span class="lib-md--filters-icon" aria-hidden="true">
            <img [src]="filterIconSrc" width="20" height="20" alt="" />
          </span>
          <span class="lib-md--filters-title">Filters</span>
          @if (activeFilterCount > 0) {
            <span class="lib-md--filter-badge">{{ activeFilterCount }}</span>
          }
        </span>
        <span class="lib-md--filters-right">
          @if (activeFilterCount > 0) {
            <button
              type="button"
              class="lib-md--clear-all"
              (click)="clearAllFilters($event)"
            >
              Clear All
            </button>
          }
          <span class="lib-md--filters-toggle" aria-hidden="true">
            <img
              [src]="chevronIconSrc"
              width="20"
              height="20"
              alt=""
              [class.lib-md--chevron-collapsed]="!filtersOpen()"
            />
          </span>
        </span>
      </div>

      @if (filtersOpen()) {
        <div class="lib-md--filters-content" (click)="$event.stopPropagation()">
          <div class="lib-md--filter-grid">
            <div class="lib-md--filter-field">
              <span class="lib-md--filter-label">Date Range</span>
              <lib-date-range-picker
                class="lib-md--activities-daterange"
                styleClass="filter-select"
                placeholder="Filter by Created At"
                [(ngModel)]="filterDateRangeValue"
                (onDateRangeChange)="onActivitiesDateRangeChange($event)"
                (onOpen)="onDateRangePickerOpen()"
                (onClose)="onDateRangePickerClose()"
              ></lib-date-range-picker>
            </div>

            <div class="lib-md--filter-field">
              <span class="lib-md--filter-label">Status</span>
              <div class="lib-md--status-dd">
                <div
                  role="button"
                  tabindex="0"
                  class="lib-md--filter-input lib-md--status-trigger"
                  [class.lib-md--status-trigger-open]="statusDropdownOpen()"
                  [class.lib-md--status-trigger-filled]="hasStatusSelection"
                  [attr.aria-expanded]="statusDropdownOpen()"
                  (click)="toggleStatusDropdown($event)"
                  (keydown.enter)="toggleStatusDropdown($event)"
                  (keydown.space)="
                    toggleStatusDropdown($event); $event.preventDefault()
                  "
                >
                  @if (!hasStatusSelection) {
                    <span
                      class="lib-md--status-trigger-text lib-md--placeholder"
                      >Choose Status</span
                    >
                  }
                  @if (hasStatusSelection && selectedStatuses.length === 1) {
                    <span class="lib-md--filter-chip">
                      {{ statusChipLabel(selectedStatuses[0]) }}
                      <button
                        type="button"
                        class="lib-md--filter-chip-remove"
                        aria-label="Remove status"
                        (click)="removeStatus(selectedStatuses[0], $event)"
                      >
                        ×
                      </button>
                    </span>
                  }
                  @if (hasStatusSelection && selectedStatuses.length > 1) {
                    <span class="lib-md--filter-chip">
                      {{ selectedStatuses.length }} selected
                      <button
                        type="button"
                        class="lib-md--filter-chip-remove"
                        aria-label="Clear status selection"
                        (click)="clearStatusSelection($event)"
                      >
                        ×
                      </button>
                    </span>
                  }
                  <img
                    [src]="statusChevronIconSrc"
                    width="20"
                    height="20"
                    alt=""
                    aria-hidden="true"
                  />
                </div>

                @if (statusDropdownOpen()) {
                  <div
                    class="lib-md--status-menu"
                    role="listbox"
                    aria-label="Status filter"
                    (click)="$event.stopPropagation()"
                  >
                    @for (opt of filterStatusOptions; track opt) {
                      <label class="lib-md--status-option">
                        <input
                          type="checkbox"
                          [checked]="isStatusChecked(opt.value)"
                          (change)="toggleStatus(opt.value, $event)"
                          (click)="$event.stopPropagation()"
                        />
                        <span>{{ opt.label }}</span>
                      </label>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="lib-md--table-wrap" [attr.aria-busy]="tableLoading">
      <table class="lib-md--table">
        <thead>
          <tr>
            <th scope="col">{{ emailColumnLabel }}</th>
            @if (showOwnerOrgColumn) {
              <th scope="col">Owner Organisation</th>
            }
            @if (showOwnerRoleColumn) {
              <th scope="col">Owner Role</th>
            }
            <th scope="col">Scope</th>
            <th scope="col">Status</th>
            <th
              scope="col"
              class="lib-md--col-date"
              [attr.aria-sort]="sortAria('createdAt')"
            >
              <button
                type="button"
                class="lib-md--sort"
                (click)="onSort('createdAt')"
              >
                Created At
                <span
                  class="lib-md--sort-icon"
                  [class.lib-md--sort-icon-active]="sortColumn === 'createdAt'"
                  aria-hidden="true"
                  >{{ sortIcon('createdAt') }}</span
                >
              </button>
            </th>
            <th
              scope="col"
              class="lib-md--col-date"
              [attr.aria-sort]="sortAria('expiryAt')"
            >
              <button
                type="button"
                class="lib-md--sort"
                (click)="onSort('expiryAt')"
              >
                Expiry At
                <span
                  class="lib-md--sort-icon"
                  [class.lib-md--sort-icon-active]="sortColumn === 'expiryAt'"
                  aria-hidden="true"
                  >{{ sortIcon('expiryAt') }}</span
                >
              </button>
            </th>
            <th scope="col" class="lib-md--col-action">Action</th>
          </tr>
        </thead>
        <tbody>
          @if (tableLoading && currentRows.length === 0) {
            <tr>
              <td [attr.colspan]="tableColumnCount" class="lib-md--empty">
                Loading…
              </td>
            </tr>
          }
          @if (!tableLoading && currentRows.length === 0) {
            <tr>
              <td [attr.colspan]="tableColumnCount" class="lib-md--empty">
                {{ emptyMessage }}
              </td>
            </tr>
          }
          @for (row of currentRows; track row) {
            <tr [class.lib-md--row-action-open]="isActionOpen(row.id)">
              <td class="lib-md--email">
                @if (activeTab() === 'owners') {
                  <span
                    class="lib-md--person-name lib-md--clip"
                    libEllipsisTooltip
                  >
                    {{ ownerDisplayName(row) }}
                  </span>
                } @else {
                  <span class="lib-md--clip" libEllipsisTooltip>{{
                    row.email
                  }}</span>
                }
              </td>
              @if (showOwnerOrgColumn) {
                <td class="lib-md--owner-org lib-md--clip" libEllipsisTooltip>
                  {{
                    isPlatformAdminOwner(row) ? '' : ownerOrgName(row) || '—'
                  }}
                </td>
              }
              @if (showOwnerRoleColumn) {
                <td class="lib-md--owner-role lib-md--clip" libEllipsisTooltip>
                  {{ ownerRoleLabel(row) }}
                </td>
              }
              <td>
                @if (scopesFor(row).length) {
                  <div class="lib-md--scope-cell">
                    <span
                      class="lib-md--scope-chip"
                      [class.lib-md--scope-chip-tip]="
                        !!scopeDescription(scopesFor(row)[0])
                      "
                      [attr.tabindex]="
                        scopeDescription(scopesFor(row)[0]) ? 0 : null
                      "
                      [attr.aria-label]="scopesFor(row)[0]"
                      [attr.aria-describedby]="
                        scopeDescription(scopesFor(row)[0])
                          ? 'lib-md-scope-tooltip'
                          : null
                      "
                      (mouseenter)="showScopeTooltip($event, scopesFor(row)[0])"
                      (mouseleave)="hideScopeTooltip()"
                      (focus)="showScopeTooltip($event, scopesFor(row)[0])"
                      (blur)="hideScopeTooltip()"
                      >{{ primaryScopeLabel(row) }}</span
                    >
                    @if (extraScopeCount(row) > 0) {
                      <button
                        type="button"
                        class="lib-md--scope-more"
                        [class.lib-md--scope-more-open]="
                          isScopesPopupOpen(row.id)
                        "
                        [attr.aria-expanded]="isScopesPopupOpen(row.id)"
                        [attr.aria-label]="
                          'Show all ' + scopesFor(row).length + ' scopes'
                        "
                        (click)="toggleScopesPopup($event, row)"
                      >
                        +{{ extraScopeCount(row) }}
                      </button>
                    }
                  </div>
                } @else {
                  —
                }
              </td>
              <td>
                <span
                  class="lib-md--status-pill"
                  [attr.data-status]="
                    row.status === 'rejected' ? 'revoked' : row.status
                  "
                  >{{ statusLabel(row.status) }}</span
                >
              </td>
              <td class="lib-md--clip lib-md--col-date" libEllipsisTooltip>
                <span class="lib-md--datetime">
                  <span class="lib-md--datetime-date">{{
                    formatDateParts(row.createdAt).date
                  }}</span>
                  @if (formatDateParts(row.createdAt).time) {
                    <span class="lib-md--datetime-time">{{
                      formatDateParts(row.createdAt).time
                    }}</span>
                  }
                </span>
              </td>
              <td class="lib-md--clip lib-md--col-date" libEllipsisTooltip>
                <span class="lib-md--datetime">
                  <span class="lib-md--datetime-date">{{
                    formatDateParts(row.expiryAt).date
                  }}</span>
                  @if (formatDateParts(row.expiryAt).time) {
                    <span class="lib-md--datetime-time">{{
                      formatDateParts(row.expiryAt).time
                    }}</span>
                  }
                </span>
              </td>
              <td class="lib-md--col-action">
                <div
                  class="action-cell-wrapper"
                  [class.action-dropdown-open]="isActionOpen(row.id)"
                >
                  <button
                    type="button"
                    class="action-btn action-btn--primary lib-md--action-trigger"
                    [class.active]="isActionOpen(row.id)"
                    [disabled]="!canUseRowAction(row)"
                    [attr.aria-disabled]="!canUseRowAction(row) ? true : null"
                    (click)="toggleActionMenu($event, row)"
                  >
                    <span class="action-btn-label">Action</span>
                    <svg
                      class="action-btn-chevron"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      aria-hidden="true"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (showPagination) {
      <p-paginator
        [rows]="pageSize"
        [totalRecords]="listTotal"
        [first]="(currentPage - 1) * pageSize"
        [showJumpToPageDropdown]="false"
        [showCurrentPageReport]="false"
        (onPageChange)="onListPageChange($event)"
        styleClass="lib-md--paginator"
      ></p-paginator>
    }
  </div>

  <!-- Add Delegate modal (Figma 6431:31052) -->
  @if (enableAddModal() && showAddModal()) {
    <div class="lib-md--modal-backdrop">
      <div
        class="lib-md--modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lib-md-add-title"
        (click)="onAddModalClick($event)"
      >
        <div class="lib-md--modal-header">
          <h2 id="lib-md-add-title">Add Delegate</h2>
          <button
            type="button"
            class="lib-md--modal-close"
            aria-label="Close"
            (click)="closeAddDelegate()"
          >
            <img [src]="closeIconSrc" width="14" height="14" alt="" />
          </button>
        </div>

        <div
          class="lib-md--modal-body"
          [class.lib-md--modal-body-locked]="scopeDropdownOpen()"
        >
          <label
            class="lib-md--field"
            [class.lib-md--field-error]="!!addFormErrors.email"
          >
            <span class="lib-md--field-label">Email Id <em>*</em></span>
            <input
              type="email"
              [(ngModel)]="addForm.email"
              (ngModelChange)="onAddEmailChange()"
              placeholder="Enter email address"
              autocomplete="off"
              [attr.aria-invalid]="!!addFormErrors.email"
            />
            @if (addFormErrors.email) {
              <span class="lib-md--field-error-msg">{{
                addFormErrors.email
              }}</span>
            }
          </label>

          <div
            class="lib-md--field"
            [class.lib-md--field-error]="!!addFormErrors.scope"
          >
            <span class="lib-md--field-label"
              >Choose Access scope <em>*</em></span
            >
            <div
              class="lib-md--scope-dd"
              [class.lib-md--scope-dd-open]="scopeDropdownOpen()"
              (click)="$event.stopPropagation()"
            >
              <div
                class="lib-md--scope-trigger"
                [class.lib-md--scope-trigger-open]="scopeDropdownOpen()"
                [class.lib-md--scope-trigger-locked]="!!singleAddScope"
                [attr.aria-invalid]="!!addFormErrors.scope"
                (click)="onScopeTriggerClick($event)"
              >
                @if (selectedAddScopes.length) {
                  <span class="lib-md--scope-trigger-chips">
                    @if (selectedAddScopes.length > 2) {
                      <span class="lib-md--filter-chip">
                        {{ selectedAddScopes.length }} selected
                        <button
                          type="button"
                          class="lib-md--filter-chip-remove"
                          aria-label="Clear all scopes"
                          (click)="clearScopeSelection($event)"
                        >
                          ×
                        </button>
                      </span>
                    }
                    @if (selectedAddScopes.length <= 2) {
                      @for (value of selectedAddScopes; track value) {
                        <span class="lib-md--filter-chip">
                          {{ addScopeLabel(value) }}
                          @if (!singleAddScope) {
                            <button
                              type="button"
                              class="lib-md--filter-chip-remove"
                              [attr.aria-label]="
                                'Clear ' + addScopeLabel(value)
                              "
                              (click)="removeAddScope(value, $event)"
                            >
                              ×
                            </button>
                          }
                        </span>
                      }
                    }
                  </span>
                }
                @if (!singleAddScope && !allAddScopesSelected) {
                  <input
                    type="text"
                    class="lib-md--scope-search"
                    [(ngModel)]="scopeSearchQuery"
                    (ngModelChange)="onScopeSearchQueryChange()"
                    (keydown)="onScopeSearchKeydown($event)"
                    (focus)="openScopeDropdown()"
                    [placeholder]="
                      selectedAddScopes.length
                        ? 'Search scopes'
                        : 'Choose Access scope'
                    "
                    autocomplete="off"
                    role="combobox"
                    aria-autocomplete="list"
                    aria-haspopup="listbox"
                    aria-controls="lib-md-scope-listbox"
                    [attr.aria-expanded]="scopeDropdownOpen()"
                    [attr.aria-activedescendant]="highlightedScopeId()"
                    [attr.aria-invalid]="!!addFormErrors.scope"
                  />
                }
                @if (!singleAddScope) {
                  <button
                    type="button"
                    class="lib-md--scope-chevron-btn"
                    [attr.aria-label]="
                      scopeDropdownOpen()
                        ? 'Hide access scopes'
                        : 'Show access scopes'
                    "
                    (click)="toggleScopeDropdown($event)"
                  >
                    <img
                      class="lib-md--scope-chevron"
                      [class.lib-md--scope-chevron-open]="scopeDropdownOpen()"
                      [src]="statusChevronIconSrc"
                      width="20"
                      height="20"
                      alt=""
                      aria-hidden="true"
                    />
                  </button>
                }
              </div>
            </div>
            @if (addFormErrors.scope) {
              <span class="lib-md--field-error-msg">{{
                addFormErrors.scope
              }}</span>
            }
          </div>

          <label
            class="lib-md--field"
            [class.lib-md--field-error]="!!addFormErrors.expiryAt"
          >
            <span class="lib-md--field-label">Expiry Date <em>*</em></span>
            <lib-date-range-picker
              class="lib-md--modal-daterange"
              styleClass="filter-select"
              placeholder="dd-mm-yyyy"
              [singleDateMode]="true"
              [disableFutureDates]="false"
              [minDate]="expiryMinDate"
              [(ngModel)]="expiryDateRangeValue"
              (onDateRangeChange)="onExpiryDateChange($event)"
              [attr.aria-invalid]="!!addFormErrors.expiryAt"
            ></lib-date-range-picker>
            @if (addFormErrors.expiryAt) {
              <span class="lib-md--field-error-msg">{{
                addFormErrors.expiryAt
              }}</span>
            }
          </label>

          <label
            class="lib-md--field"
            [class.lib-md--field-error]="!!addFormErrors.comments"
          >
            <span class="lib-md--field-label">Comments <em>*</em></span>
            <div class="lib-md--textarea-wrap">
              <textarea
                [(ngModel)]="addForm.comments"
                (ngModelChange)="clearAddFieldError('comments')"
                placeholder="Enter comments"
                rows="4"
                [maxlength]="commentsMaxLength"
                [attr.aria-invalid]="!!addFormErrors.comments"
              ></textarea>
              <span class="lib-md--char-count"
                >{{ addForm.comments.length }}/{{ commentsMaxLength }}</span
              >
            </div>
            @if (addFormErrors.comments) {
              <span class="lib-md--field-error-msg">{{
                addFormErrors.comments
              }}</span>
            }
          </label>
          @if (addFormErrors.submit) {
            <span class="lib-md--field-error-msg">{{
              addFormErrors.submit
            }}</span>
          }
        </div>

        <div class="lib-md--modal-footer">
          <button
            type="button"
            class="lib-md--btn-create"
            [disabled]="addSubmitting()"
            (click)="submitAddDelegate()"
          >
            {{
              addSubmitting()
                ? existingDelegateForAdd
                  ? 'Updating…'
                  : 'Creating…'
                : existingDelegateForAdd
                  ? 'Update Delegate'
                  : 'Create Delegate'
            }}
          </button>
        </div>
      </div>
    </div>
  }
</div>

@if (
  enableAddModal() && showAddModal() && scopeDropdownOpen() && !singleAddScope
) {
  <div
    class="lib-md--scope-menu"
    role="listbox"
    id="lib-md-scope-listbox"
    aria-multiselectable="true"
    aria-label="Choose Access scope"
    [style.top.px]="scopeMenuPosition.top"
    [style.left.px]="scopeMenuPosition.left"
    [style.width.px]="scopeMenuPosition.width"
    [style.maxHeight.px]="scopeMenuPosition.maxHeight"
    (click)="$event.stopPropagation()"
  >
    @if (!filteredScopeOptions.length) {
      <div class="lib-md--scope-empty">No matching scopes</div>
    }
    @for (opt of filteredScopeOptions; track opt; let i = $index) {
      <button
        type="button"
        class="lib-md--scope-option"
        role="option"
        [id]="scopeOptionDomId(opt.value)"
        [disabled]="opt.disabled"
        [attr.aria-disabled]="opt.disabled ? true : null"
        [attr.aria-selected]="
          !opt.disabled && selectedAddScopes.includes(opt.value)
        "
        [attr.title]="
          opt.disabled
            ? isAddScopeAlreadyGranted(opt.value)
              ? 'Already granted'
              : opt.badge || 'Coming soon'
            : addScopeDescription(opt)
        "
        [class.lib-md--scope-option-selected]="
          !opt.disabled && selectedAddScopes.includes(opt.value)
        "
        [class.lib-md--scope-option-active]="
          !opt.disabled && i === highlightedScopeIndex
        "
        [class.lib-md--scope-option-disabled]="opt.disabled"
        (mousedown)="$event.preventDefault()"
        (click)="selectScope(opt.value, $event)"
      >
        <span
          class="lib-md--scope-check"
          [class.lib-md--scope-check-on]="
            !opt.disabled && selectedAddScopes.includes(opt.value)
          "
          aria-hidden="true"
        ></span>
        <span class="lib-md--scope-option-text">
          <span class="lib-md--scope-option-label-row">
            <span class="lib-md--scope-option-label">{{ opt.label }}</span>
            @if (opt.badge) {
              <span class="lib-md--scope-option-badge">{{ opt.badge }}</span>
            }
          </span>
          @if (addScopeDescription(opt)) {
            <span class="lib-md--scope-option-desc">{{
              addScopeDescription(opt)
            }}</span>
          }
        </span>
      </button>
    }
  </div>
}

<!-- Figma 6448:30334 — Revoke / Delete confirmation -->
@if (showConfirmModal()) {
  <div class="lib-md--confirm-backdrop" (click)="closeConfirmModal()">
    <div
      class="lib-md--confirm-modal"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="'lib-md-confirm-title'"
      (click)="$event.stopPropagation()"
    >
      <img
        class="lib-md--confirm-leaf"
        [src]="revokeLeafImageSrc"
        alt=""
        aria-hidden="true"
      />
      <button
        type="button"
        class="lib-md--confirm-close"
        aria-label="Close"
        [disabled]="confirmSubmitting()"
        (click)="closeConfirmModal()"
      >
        <img [src]="closeIconSrc" width="20" height="20" alt="" />
      </button>

      <div class="lib-md--confirm-icon" aria-hidden="true">
        <img [src]="revokeTrashIconSrc" width="64" height="64" alt="" />
      </div>

      <h2 id="lib-md-confirm-title" class="lib-md--confirm-title">
        {{
          confirmMode() === 'revoke'
            ? 'Revoke Delegated Access?'
            : 'Delete Delegate?'
        }}
      </h2>

      @if (confirmMode() === 'revoke') {
        <p class="lib-md--confirm-body">
          You will no longer be able to act on behalf of
          <strong class="lib-md--confirm-email">{{ confirmPersonEmail }}</strong
          >.
          <br />
          Are you sure you want to revoke?
        </p>
      }
      @if (confirmMode() === 'delete') {
        <p class="lib-md--confirm-body">
          You are about to remove delegate access for
          <strong class="lib-md--confirm-email">{{ confirmPersonEmail }}</strong
          >.
          <br />
          Are you sure you want to delete?
        </p>
      }

      <div class="lib-md--confirm-actions">
        <button
          type="button"
          class="lib-md--confirm-cancel"
          [disabled]="confirmSubmitting()"
          (click)="closeConfirmModal()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="lib-md--confirm-danger"
          [disabled]="confirmSubmitting()"
          (click)="confirmDestructiveAction()"
        >
          {{
            confirmSubmitting()
              ? confirmMode() === 'revoke'
                ? 'Revoking…'
                : 'Deleting…'
              : confirmMode() === 'revoke'
                ? 'Revoke'
                : 'Delete'
          }}
        </button>
      </div>
    </div>
  </div>
}

@if (showRequestModal() && requestTarget(); as owner) {
  <div class="lib-md--modal-backdrop" (click)="closeRequestModal()">
    <div
      class="lib-md--modal lib-md--request-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="lib-md-request-title"
      (click)="$event.stopPropagation()"
    >
      <div class="lib-md--modal-header">
        <h2 id="lib-md-request-title">Request additional scopes</h2>
        <button
          type="button"
          class="lib-md--modal-close"
          aria-label="Close"
          (click)="closeRequestModal()"
        >
          <img [src]="closeIconSrc" width="14" height="14" alt="" />
        </button>
      </div>

      <div class="lib-md--modal-body">
        <div
          class="lib-md--owner-card"
          [class.lib-md--owner-card-no-org]="isPlatformAdminOwner(owner)"
        >
          <div class="lib-md--owner-card-item">
            <span class="lib-md--field-label">Owner name</span>
            <span class="lib-md--owner-card-value" libEllipsisTooltip>{{
              ownerDisplayName(owner)
            }}</span>
          </div>
          @if (!isPlatformAdminOwner(owner)) {
            <div class="lib-md--owner-card-item">
              <span class="lib-md--field-label">Organisation</span>
              <span class="lib-md--owner-card-value" libEllipsisTooltip>{{
                ownerOrgName(owner) || '—'
              }}</span>
            </div>
          }
          <div class="lib-md--owner-card-item">
            <span class="lib-md--field-label">Owner role</span>
            <span class="lib-md--owner-card-value">{{
              ownerRoleLabel(owner)
            }}</span>
          </div>
        </div>

        <div class="lib-md--scope-view">
          <div class="lib-md--scope-view-heading">
            <span class="lib-md--field-label">Scopes</span>
            <span class="lib-md--scope-view-hint"
              >Check a scope to request it. Uncheck a granted scope to revoke
              it.</span
            >
          </div>
          <div class="lib-md--scope-view-panel">
            <div class="lib-md--scope-view-role-label">
              {{ ownerRoleLabel(owner) }}
            </div>
            <ul class="lib-md--scope-view-scopes">
              @for (item of requestScopeItems(); track item) {
                <li
                  class="lib-md--scope-view-scope lib-md--scope-view-scope-selectable"
                  [class.lib-md--scope-view-scope-granted]="
                    item.granted && isRequestScopeSelected(item.label)
                  "
                  [class.lib-md--scope-view-scope-selected]="
                    isRequestingNewScope(item)
                  "
                  [class.lib-md--scope-view-scope-revoking]="
                    isRevokingGrantedScope(item)
                  "
                  role="checkbox"
                  tabindex="0"
                  [attr.aria-checked]="isRequestScopeSelected(item.label)"
                  (click)="toggleRequestScope(item.label, $event)"
                  (keydown.enter)="toggleRequestScope(item.label, $event)"
                  (keydown.space)="
                    toggleRequestScope(item.label, $event);
                    $event.preventDefault()
                  "
                >
                  <span
                    class="lib-md--scope-check"
                    [class.lib-md--scope-check-on]="
                      isRequestScopeSelected(item.label)
                    "
                    aria-hidden="true"
                  ></span>
                  <span class="lib-md--scope-view-scope-label">{{
                    displayScopeLabel(item.label)
                  }}</span>
                  @if (item.granted && isRequestScopeSelected(item.label)) {
                    <span class="lib-md--status-pill" data-status="active"
                      >Granted</span
                    >
                  }
                  @if (isRequestingNewScope(item)) {
                    <span class="lib-md--status-pill" data-status="requesting"
                      >Requesting</span
                    >
                  }
                  @if (isRevokingGrantedScope(item)) {
                    <span class="lib-md--status-pill" data-status="revoked"
                      >Revoke</span
                    >
                  }
                </li>
              }
            </ul>
          </div>
        </div>
      </div>

      <div class="lib-md--modal-footer">
        <button
          type="button"
          class="lib-md--btn-secondary"
          (click)="closeRequestModal()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="lib-md--btn-create"
          [disabled]="!canSubmitScopeRequest"
          (click)="submitScopeRequest()"
        >
          Request
        </button>
      </div>
    </div>
  </div>
}

@if (showDowngradeModal() && downgradeTarget(); as delegate) {
  <div class="lib-md--modal-backdrop" (click)="closeDowngradeModal()">
    <div
      class="lib-md--modal lib-md--request-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="lib-md-downgrade-title"
      (click)="$event.stopPropagation()"
    >
      <div class="lib-md--modal-header">
        <h2 id="lib-md-downgrade-title">Downgrade scopes</h2>
        <button
          type="button"
          class="lib-md--modal-close"
          aria-label="Close"
          (click)="closeDowngradeModal()"
        >
          <img [src]="closeIconSrc" width="14" height="14" alt="" />
        </button>
      </div>

      <div class="lib-md--modal-body">
        <div class="lib-md--owner-card lib-md--owner-card-no-org">
          <div class="lib-md--owner-card-item">
            <span class="lib-md--field-label">Delegate</span>
            <span class="lib-md--owner-card-value" libEllipsisTooltip>{{
              delegate.email
            }}</span>
          </div>
          <div class="lib-md--owner-card-item">
            <span class="lib-md--field-label">Status</span>
            <span class="lib-md--owner-card-value">{{
              statusLabel(delegate.status)
            }}</span>
          </div>
        </div>

        <div class="lib-md--scope-view">
          <div class="lib-md--scope-view-heading">
            <span class="lib-md--field-label">Current scopes</span>
            <span class="lib-md--scope-view-hint">
              Uncheck a scope to remove it.
              @if (willDeleteGrantOnDowngrade) {
                Removing the last scope deletes this grant.
              }
            </span>
          </div>
          <div class="lib-md--scope-view-panel">
            <ul class="lib-md--scope-view-scopes">
              @for (scope of downgradeScopeItems(); track scope) {
                <li
                  class="lib-md--scope-view-scope lib-md--scope-view-scope-selectable"
                  [class.lib-md--scope-view-scope-granted]="
                    isDowngradeScopeSelected(scope)
                  "
                  [class.lib-md--scope-view-scope-revoking]="
                    isRemovingDowngradeScope(scope)
                  "
                  role="checkbox"
                  tabindex="0"
                  [attr.aria-checked]="isDowngradeScopeSelected(scope)"
                  (click)="toggleDowngradeScope(scope, $event)"
                  (keydown.enter)="toggleDowngradeScope(scope, $event)"
                  (keydown.space)="
                    toggleDowngradeScope(scope, $event); $event.preventDefault()
                  "
                >
                  <span
                    class="lib-md--scope-check"
                    [class.lib-md--scope-check-on]="
                      isDowngradeScopeSelected(scope)
                    "
                    aria-hidden="true"
                  ></span>
                  <span class="lib-md--scope-option-text">
                    <span class="lib-md--scope-option-label-row">
                      <span class="lib-md--scope-view-scope-label">{{
                        addScopeLabel(scope)
                      }}</span>
                      @if (isDowngradeScopeSelected(scope)) {
                        <span class="lib-md--status-pill" data-status="active"
                          >Active</span
                        >
                      }
                      @if (isRemovingDowngradeScope(scope)) {
                        <span class="lib-md--status-pill" data-status="revoked"
                          >Remove</span
                        >
                      }
                    </span>
                    @if (scopeDescription(scope)) {
                      <span class="lib-md--scope-option-desc">{{
                        scopeDescription(scope)
                      }}</span>
                    }
                  </span>
                </li>
              }
            </ul>
          </div>
        </div>
        @if (downgradeError) {
          <span class="lib-md--field-error-msg">{{ downgradeError }}</span>
        }
      </div>

      <div class="lib-md--modal-footer">
        <button
          type="button"
          class="lib-md--btn-secondary"
          [disabled]="downgradeSubmitting()"
          (click)="closeDowngradeModal()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="lib-md--btn-create"
          [disabled]="!canSubmitDowngrade"
          (click)="submitDowngrade()"
        >
          {{
            downgradeSubmitting()
              ? willDeleteGrantOnDowngrade
                ? 'Deleting…'
                : 'Updating…'
              : willDeleteGrantOnDowngrade
                ? 'Delete grant'
                : 'Remove scopes'
          }}
        </button>
      </div>
    </div>
  </div>
}

@if (showUpgradeModal() && upgradeTarget(); as delegate) {
  <div class="lib-md--modal-backdrop" (click)="closeUpgradeModal()">
    <div
      class="lib-md--modal lib-md--request-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="lib-md-upgrade-title"
      (click)="$event.stopPropagation()"
    >
      <div class="lib-md--modal-header">
        <h2 id="lib-md-upgrade-title">Upgrade scopes</h2>
        <button
          type="button"
          class="lib-md--modal-close"
          aria-label="Close"
          (click)="closeUpgradeModal()"
        >
          <img [src]="closeIconSrc" width="14" height="14" alt="" />
        </button>
      </div>

      <div class="lib-md--modal-body">
        <div class="lib-md--owner-card lib-md--owner-card-no-org">
          <div class="lib-md--owner-card-item">
            <span class="lib-md--field-label">Delegate</span>
            <span class="lib-md--owner-card-value" libEllipsisTooltip>{{
              delegate.email
            }}</span>
          </div>
          <div class="lib-md--owner-card-item">
            <span class="lib-md--field-label">Status</span>
            <span class="lib-md--owner-card-value">{{
              statusLabel(delegate.status)
            }}</span>
          </div>
        </div>

        <div class="lib-md--scope-view">
          <div class="lib-md--scope-view-heading">
            <span class="lib-md--field-label">Available scopes</span>
            <span class="lib-md--scope-view-hint">
              Check a scope to add it to this delegate.
            </span>
          </div>
          <div class="lib-md--scope-view-panel">
            <ul class="lib-md--scope-view-scopes">
              @for (scope of upgradeScopeItems(); track scope) {
                <li
                  class="lib-md--scope-view-scope lib-md--scope-view-scope-selectable"
                  [class.lib-md--scope-view-scope-selected]="
                    isUpgradeScopeSelected(scope)
                  "
                  role="checkbox"
                  tabindex="0"
                  [attr.aria-checked]="isUpgradeScopeSelected(scope)"
                  (click)="toggleUpgradeScope(scope, $event)"
                  (keydown.enter)="toggleUpgradeScope(scope, $event)"
                  (keydown.space)="
                    toggleUpgradeScope(scope, $event); $event.preventDefault()
                  "
                >
                  <span
                    class="lib-md--scope-check"
                    [class.lib-md--scope-check-on]="
                      isUpgradeScopeSelected(scope)
                    "
                    aria-hidden="true"
                  ></span>
                  <span class="lib-md--scope-option-text">
                    <span class="lib-md--scope-option-label-row">
                      <span class="lib-md--scope-view-scope-label">{{
                        addScopeLabel(scope)
                      }}</span>
                      @if (isUpgradeScopeSelected(scope)) {
                        <span
                          class="lib-md--status-pill"
                          data-status="requesting"
                          >Add</span
                        >
                      }
                    </span>
                    @if (scopeDescription(scope)) {
                      <span class="lib-md--scope-option-desc">{{
                        scopeDescription(scope)
                      }}</span>
                    }
                  </span>
                </li>
              }
            </ul>
          </div>
        </div>
        @if (upgradeError) {
          <span class="lib-md--field-error-msg">{{ upgradeError }}</span>
        }
      </div>

      <div class="lib-md--modal-footer">
        <button
          type="button"
          class="lib-md--btn-secondary"
          [disabled]="upgradeSubmitting()"
          (click)="closeUpgradeModal()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="lib-md--btn-create"
          [disabled]="!canSubmitUpgrade"
          (click)="submitUpgrade()"
        >
          {{ upgradeSubmitting() ? 'Adding…' : 'Add scopes' }}
        </button>
      </div>
    </div>
  </div>
}

@if (openActionRow(); as actionRow) {
  <div
    class="lib-md--action-menu"
    [style.top.px]="dropdownPosition.top"
    [style.left.px]="dropdownPosition.left"
    (click)="$event.stopPropagation()"
  >
    <ul class="dropdown-list">
      @if (activeTab() === 'delegates' && canUpgradeDelegate($any(actionRow))) {
        <li class="dropdown-item">
          <button
            type="button"
            class="dropdown-link"
            (click)="onUpgradeDelegate($any(actionRow))"
          >
            Upgrade scopes
          </button>
        </li>
      }
      @if (
        activeTab() === 'delegates' && canDowngradeDelegate($any(actionRow))
      ) {
        <li class="dropdown-item">
          <button
            type="button"
            class="dropdown-link"
            (click)="onDowngradeDelegate($any(actionRow))"
          >
            Downgrade scopes
          </button>
        </li>
      }
      @if (activeTab() === 'delegates' && canDeleteDelegate($any(actionRow))) {
        <li class="dropdown-item">
          <button
            type="button"
            class="dropdown-link dropdown-link--danger"
            (click)="onDeleteDelegate($any(actionRow))"
          >
            Delete
          </button>
        </li>
      }
      @if (activeTab() === 'owners' && canRevokeOwner($any(actionRow))) {
        <li class="dropdown-item">
          <button
            type="button"
            class="dropdown-link dropdown-link--danger"
            (click)="onRevokeOwner($any(actionRow))"
          >
            Revoke
          </button>
        </li>
      }
      @if (activeTab() === 'owners' && canSwitchOwner($any(actionRow))) {
        <li class="dropdown-item">
          <button
            type="button"
            class="dropdown-link"
            (click)="onSwitchOwner($any(actionRow))"
          >
            Switch
          </button>
        </li>
      }
    </ul>
  </div>
}

@if (openScopesRow(); as scopesRow) {
  <div
    class="lib-md--scopes-popup"
    [style.top.px]="scopesPopupPosition.top"
    [style.left.px]="scopesPopupPosition.left"
    role="dialog"
    [attr.aria-label]="'Access scopes'"
    (click)="$event.stopPropagation()"
  >
    <div class="lib-md--scopes-popup-header">
      <span class="lib-md--scopes-popup-title">Access scopes</span>
      <span class="lib-md--scopes-popup-count">{{
        scopeStatesFor(scopesRow).length
      }}</span>
    </div>
    <ul class="lib-md--scopes-popup-list" role="list">
      @for (item of scopeStatesFor(scopesRow); track item) {
        <li class="lib-md--scopes-popup-item" role="listitem">
          <span
            class="lib-md--scopes-popup-name"
            [class.lib-md--scope-chip-tip]="!!scopeDescription(item.label)"
            [attr.tabindex]="scopeDescription(item.label) ? 0 : null"
            [attr.aria-label]="displayScopeLabel(item.label)"
            (mouseenter)="showScopeTooltip($event, item.label)"
            (mouseleave)="hideScopeTooltip()"
            (focus)="showScopeTooltip($event, item.label)"
            (blur)="hideScopeTooltip()"
            >{{ displayScopeLabel(item.label) }}</span
          >
          <span class="lib-md--status-pill" [attr.data-status]="item.status">{{
            statusLabel(item.status)
          }}</span>
        </li>
      }
    </ul>
  </div>
}

@if (scopeTooltip(); as tip) {
  <div
    class="lib-md--scope-tooltip"
    id="lib-md-scope-tooltip"
    role="tooltip"
    [class.lib-md--scope-tooltip-above]="scopeTooltipPosition.above"
    [style.top.px]="scopeTooltipPosition.top"
    [style.left.px]="scopeTooltipPosition.left"
  >
    <span class="lib-md--scope-tooltip-label">{{ tip.label }}</span>
    <span class="lib-md--scope-tooltip-text">{{ tip.text }}</span>
  </div>
}
